import { render, staticRenderFns } from "./HowItWork.vue?vue&type=template&id=50104057&scoped=true&"
import script from "./HowItWork.vue?vue&type=script&lang=js&"
export * from "./HowItWork.vue?vue&type=script&lang=js&"
import style0 from "./HowItWork.vue?vue&type=style&index=0&id=50104057&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50104057",
  null
  
)

export default component.exports